import { hasAnyPermission } from "../../utils/helpers/permissions";

export const quantity = (value) => Number(value || 0).toLocaleString("id-ID");
export const TYPES = { issue: "Penyerahan", return: "Pengembalian", loss: "Rusak / hilang" };
export const STATUS = {
  pending: { label: "Menunggu diterima", tone: "bg-warning-lt" },
  received: { label: "Selesai", tone: "bg-success-lt" },
  cancelled: { label: "Dibatalkan", tone: "bg-secondary-lt" },
};
export const HISTORY_TYPES = { issue: "Penyerahan diajukan", issue_receive: "Penyerahan diterima", issue_cancel: "Penyerahan dibatalkan", return: "Pengembalian diajukan", return_receive: "Diterima outlet", return_cancel: "Pengembalian dibatalkan", sale: "Penjualan", sale_reversal: "Koreksi penjualan", loss: "Rusak / hilang" };
export const canManage = (profile) => hasAnyPermission(profile, ["manage-seller-stocks"]);
export const documentActions = (document, profile) => {
  if (!document || document.status !== "pending" || document.type === "loss") return [];
  const own = Number(document.seller_id) === Number(profile?.id);
  const allowed = (permission) => hasAnyPermission(profile, [`${permission}-seller-stocks`]);
  const result = [];
  if (document.type === "issue" ? own && allowed("receive") : canManage(profile) && allowed("process")) result.push("receive");
  if (document.type === "issue" ? canManage(profile) && allowed("create") : own && allowed("return")) result.push("cancel");
  return result;
};

export const validateDocument = (form, products, balances) => {
  const errors = {};
  if (!form.seller_id) errors.seller_id = "Pilih seller penerima.";
  if (!form.note.trim()) errors.note = "Isi keterangan penyerahan atau alasan pengembalian/penyesuaian.";
  const seen = new Set();
  form.details.forEach((line, index) => {
    const product = products.find((item) => Number(item.id) === Number(line.product_id));
    const available = form.type === "issue" ? Number(product?.available_qty || 0)
      : Number(balances.find((item) => Number(item.seller_id) === Number(form.seller_id) && Number(item.product_id) === Number(line.product_id))?.stock || 0);
    if (!product || seen.has(Number(line.product_id))) errors[`product-${index}`] = "Pilih produk yang belum ditambahkan.";
    seen.add(Number(line.product_id));
    if (!Number.isInteger(Number(line.qty)) || Number(line.qty) <= 0) errors[`qty-${index}`] = "Isi jumlah bulat lebih dari 0.";
    else if (Number(line.qty) > available) errors[`qty-${index}`] = `Maksimal ${quantity(available)} ${product?.unit || "pcs"}.`;
  });
  return errors;
};
